
module dg.objects {

    export class PropertyDisplayerControllerBase<TValue> {
        private objectDisplayerCtrl: ObjectDisplayerController;

        constructor() {
            let a = this.objectDisplayerCtrl;
        }
        $onInit = () => {
            this.objectDisplayerCtrl.OnValueChanged((newValue: any) => {
                this.domainObject = newValue;
                this.value = newValue[this.propertyId];
                this.propMeta = this.domainObject.dgMeta.properties[this.propertyId];
                this.init();
            });
        };

        protected init() {

        }

        protected domainObject: dg.domain.IDomainObject;
        //protected get propMeta() { return this.domainObject.dgMeta.properties[this.propertyId]; }
        protected propMeta: dg.restfulApi.DomainObjectPropertyMetadata;

        //public get value(): TValue { return this.domainObject[this.propertyId]; }
        public value: TValue;
        public options: any;
        public propertyId: string;
    }

    import DG_DATA_TYPES = dg.restfulApi.DG_DATA_TYPES;
    import DG_PROPERTY_TYPES = dg.restfulApi.PropertyType;


    export interface IPropertyDisplayerScope extends ng.IScope {
        propertyId: string
        propMeta: dg.restfulApi.DomainObjectPropertyMetadata;
        options: any;
        domainObject: dg.domain.IDomainObject;
    }

    function propertyDisplayer(
        $compile,
        $parse: ng.IParseService,
        objectService: dg.objects.ObjectService,
        $filter: dgUtils.IFilterService): ng.IDirective {
        return {
            restrict: 'A',
            priority: 900,
            terminal: true,
            scope: {
                propertyId: '<propertyDisplayer',
                options: '<'
            },
            require: ['^objectDisplayer'],
            //  templateUrl: '/digmo/src/objects/properties/property-displayer.html',
            replace: true,
            link: (scope: IPropertyDisplayerScope, instanceElement: ng.IAugmentedJQuery, instanceAttributes: ng.IAttributes, controllers, transclude: ng.ITranscludeFunction) => {

                let objectDisplayerController: ObjectDisplayerController = controllers[0];
                //scope.domainObject = objectEditorController.value;

                let compiled = false;

                let compileDisplayer = () => {


                    //directive recompilation
                    let element = angular.element('<span/>');

                    if (scope.propMeta.propertyType == "ChildObject") {
                        element = angular.element('<child-list/>');
                        //element.attr('child-list', '');
                    }
                    else if (scope.propMeta.propertyType == "Reference") {
                        if (scope.propMeta.referencedObject) {
                            element = angular.element('<reference-displayer template-type="' + scope.propMeta.referencedObject + '"/>');
                        }
                        else {
                            element = angular.element('<reference-displayer />');
                        }

                        //element.attr('reference-displayer', '');
                    } else {
                        //scalar
                        if (scope.propMeta.dataType == DG_DATA_TYPES.Date
                            || scope.propMeta.dataType == DG_DATA_TYPES.DateTime) {

                            element = angular.element('<date-displayer/>');
                            element.attr('date-type', scope.propMeta.dataType);
                        } else if (scope.propMeta.dataType == DG_DATA_TYPES.EmailAddress) {
                            element = angular.element('<email-displayer/>');
                        } else if (scope.propMeta.dataType == DG_DATA_TYPES.Url) {
                            element = angular.element('<url-displayer/>');
                        } else if (scope.propMeta.dataType == DG_DATA_TYPES.MultilineText) {
                            element = angular.element('<multiline-text-displayer/>');
                        } else if (scope.propMeta.dataType == DG_DATA_TYPES.RichText) {
                            element.attr('wysiwyg-displayer', '');
                            //} else if (scope.propMeta.dataType == DG_DATA_TYPES.externalFile) {
                            //    if (!propValue.hasFile) {
                            //        //add action delayers if file upload is allowed
                            //        var invokeLinks = $filter('dgLinksByRel')(scope.dgMeta.links, DG_LINK_RELS.invoke);
                            //    }
                            //} else if (scope.propMeta.dataType == DG_DATA_TYPES.base64File) {
                            //    element = angular.element('<base64-file/>');

                        }
                        else if (scope.propMeta.dataType == DG_DATA_TYPES.Period) {
                            element = angular.element('<period-displayer/>');
                        }
                        else if (scope.propMeta.dataType == DG_DATA_TYPES.DateRange || scope.propMeta.dataType == DG_DATA_TYPES.MonthRange) {
                            element = angular.element('<date-range-displayer />');
                        } else if (scope.propMeta.dataType == DG_DATA_TYPES.Bool) {
                            element = angular.element('<bool-displayer/>');
                        } else if (scope.propMeta.dataType == DG_DATA_TYPES.Amount) {
                            element = angular.element('<amount-displayer number-format="2"/>');
                        } else if (scope.propMeta.dataType == DG_DATA_TYPES.Percent) {
                            element = angular.element('<amount-displayer precision=' + scope.propMeta.precision + ' unit="%"/>');
                        } else if (scope.propMeta.dataType == DG_DATA_TYPES.Number) {
                            element = angular.element('<amount-displayer precision=' + scope.propMeta.precision + '/>');
                        }
                        else if (objectService.templateExists(scope.propMeta.dataType.toLowerCase())) {
                            element = angular.element('<value-object-displayer template-type="' + scope.propMeta.dataType + '"/>');
                        }
                        else {
                            let hasLink = scope.propMeta.links && scope.propMeta.links.navigate;
                            let linkText = '';
                            if (hasLink) {
                                linkText = 'show-link="true"';
                            }

                            element = angular.element(`<text-displayer ${linkText}/>`);
                        }
                    }

                    element.attr('id', scope.propMeta.id);
                    element.attr('name', scope.propMeta.id);
                    //element.attr('ng-disabled', scope.propMeta.readOnly);
                    //element.attr('prop-meta', 'propMeta');

                    let propValue = "domainObject." + scope.propMeta.id;
                    element.attr('value', propValue);

                    element.attr('options', 'options');
                    element.attr('property-id', '{{::propertyId}}');
                    //custom directive recompilation
                    element.removeAttr('property-displayer');
                    element.removeAttr('ng-repeat');

                    instanceElement.prepend(element);
                    instanceElement.removeAttr('property-displayer');
                    instanceElement.removeAttr('ng-repeat');
                    $compile(element)(scope);

                    compiled = true;

                }

                let initialize = () => {
                    if (!compiled) {
                        scope.propMeta = scope.domainObject.dgMeta.properties[scope.propertyId];

                        if (!scope.propMeta) {
                            throw Error(`Property ${scope.propertyId} is missing`);
                        }
                        compileDisplayer();
                    }
                }

                objectDisplayerController.OnValueChanged(newValue => {
                    scope.domainObject = newValue;

                    if (scope.propertyId) {
                        initialize();
                    }
                });

                let watchDestroy = scope.$watch('propertyId', (propName: string) => {
                    if (scope.domainObject) {
                        initialize();
                    }
                    watchDestroy();
                });
            }
        };
    }



    angular.module('dg.objects')
        .directive('propertyDisplayer', propertyDisplayer);
}